import { TestIdDomain } from 'constants/testIds';

const FeeProviderLocationTableTestIdsScope = {
  FEE_PROVIDER_LOCATION_FORM: 'fee-provider-location-form',
};

export const CellIds = {
  STREET_ADDRESS: 'streetAddress',
  SUITE: 'suite',
  CITY: 'city',
  STATE: 'state',
  ZIP_CODE: 'zipCode',
  CONTACT_PERSON: 'contactPerson',
  CONTACT_PHONE: 'contactPhone',
  CONTACT_EMAIL: 'contactEmail',
  PHONE: 'phone',
  EMAIL: 'email',
  LICENSE_NUMBER: 'licenseNumber',
  ACCOUNT_NAME: 'accountName',
  ROUTING_NUMBER: 'routingNumber',
  ACCOUNT_NUMBER: 'accountNumber',
};

export const FeeProviderLocationTableTestIds = {
  // FeeProviderLocationForm
  FEE_PROVIDER_LOCATION_FORM_CITY_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.city-input`,
  FEE_PROVIDER_LOCATION_FORM_CONTACT_EMAIL_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.contact-email-input`,
  FEE_PROVIDER_LOCATION_FORM_CONTACT_PERSON_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.contact-person-input`,
  FEE_PROVIDER_LOCATION_FORM_CONTACT_PHONE_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.contact-phone-input`,
  FEE_PROVIDER_LOCATION_FORM_EMAIL_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.email-input`,
  FEE_PROVIDER_LOCATION_FORM_SUBMIT_BUTTON: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.submit-button`,
  FEE_PROVIDER_LOCATION_FORM: 'fee-provider-location.form',
  FEE_PROVIDER_LOCATION_FORM_LICENSE_NUMBER_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.license-number-input`,
  FEE_PROVIDER_LOCATION_FORM_PHONE_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.phone-input`,
  FEE_PROVIDER_LOCATION_FORM_STATE_SELECT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.state-select`,
  FEE_PROVIDER_LOCATION_FORM_STREET_ADDRESS_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.street-address-input`,
  FEE_PROVIDER_LOCATION_FORM_SUITE_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.suite-input`,
  FEE_PROVIDER_LOCATION_FORM_WIRE_INFORMATION_STATE_SELECT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.wire-information-state-select`,
  FEE_PROVIDER_LOCATION_FORM_WIRE_INFORMATION_ABA_NUMBER_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.wire-information-aba-number-input`,
  FEE_PROVIDER_LOCATION_FORM_WIRE_INFORMATION_ACCOUNT_NUMBER_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.wire-information-account-number-input`,
  FEE_PROVIDER_LOCATION_FORM_WIRE_INFORMATION_BANK_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.wire-information-bank-input`,
  FEE_PROVIDER_LOCATION_FORM_WIRE_INFORMATION_CITY_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.wire-information-city-input`,
  FEE_PROVIDER_LOCATION_FORM_ZIP_CODE_INPUT: `${FeeProviderLocationTableTestIdsScope.FEE_PROVIDER_LOCATION_FORM}.zip-code-input`,

  // FeeProviderLocationTable
  PROVIDER_LOCATION_TABLE: 'provider-location.table',

  // FeeProviderLocationTable (inline)
  ADD_PROVIDER_LOCATION_BUTTON: `${TestIdDomain.FEE_PROVIDERS}.add-provider-location-button`,
};
